import { createContext, ReactNode, useState } from 'react'
import { IAuthContext } from '../types/auth.type'
import { IUser } from '../../shared/types/api/user.type'
import { getUserByEmail } from '../services/auth.service'
import { useKeycloak } from '@react-keycloak/web'

export const AuthContext = createContext<IAuthContext>({
  user: null,
  errorMsg: '',
  getUser: () => {},
})

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [user, setUser] = useState<IUser | null>(null)
  const [errorMsg, setErrorMsg] = useState('')
  const { keycloak } = useKeycloak()

  const getUser = async () => {
    if (keycloak.token) {
      const body = await getUserByEmail(keycloak.token)

      if (body.data) {
        setUser(body.data)
        setErrorMsg('')
      } else if (!body.success) {
        console.error(body.message)
        setErrorMsg(body.message)
      }
    }
  }

  return <AuthContext.Provider value={{ user, errorMsg, getUser }}>{children}</AuthContext.Provider>
}
